/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const ref_number = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M13.749 2.5H2.25a1 1 0 0 0-1 1v9.045a1 1 0 0 0 1 1h11.499a1 1 0 0 0 1-1V3.5a1 1 0 0 0-1-1Z"
    />
    <path
      fill="#000"
      d="M5.296 10.274H6.33l-.884-1.686c.528-.167.825-.582.825-1.194 0-.808-.522-1.277-1.42-1.277H3.195v4.157h.89V8.671h.446l.766 1.603ZM4.085 6.83h.623c.452 0 .66.178.66.564 0 .386-.208.564-.66.564h-.623V6.83Zm5.362 0v-.713H6.894v4.157h2.553v-.713H7.785V8.558H9.21v-.713H7.785V6.83h1.662Zm3.312 0v-.713h-2.554v4.157h.891V8.558h1.425v-.713h-1.425V6.83h1.663Z"
    />
  </svg>
)
export default ref_number
